<nav class="bd-subnavbar py-3" aria-label="Secondary navigation">
  <div class="container-fluid align-items-md-center">
    <form
      class="col-lg-12 col-md-12 position-relative me-auto d-flex search-form"
    >
      <!-- show-mobile-view-search -->

      <div class="show-small-screen-search input-group input-group-lg">
        <input
          type="search"
          size="30"
          class="search-box boxz form-control"
          placeholder="Search for illustrations"
          aria-label="Recipient's username"
          aria-describedby="button-addon2"
          [formControl]="typeahead"
          (input)="suggest()"
        />
        <a
          [routerLink]="['/search/']"
          [queryParams]="{ value: typeahead.value, searchKey: searchKey }"
          class="btn btn-ib-light"
          id="button-addon2"
        >
          <i class="fas fa-search"></i>
        </a>
      </div>

      <!-- show-desktop-view-search -->
      <div class="show-lg-screen-search input-group input-group-lg">
        <button
          class="ft-size lgt boxz btn dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i
            [ngClass]="{
              'fas fa-image': searchKey === 'illus',
              'fas fa-layer-group': searchKey === 'collect'
            }"
          ></i>

          <span class="d-none d-md-inline">{{ searchKey }}</span>
        </button>

        <ul
          class="dropdown-menu shadow mb-5 bg-body rounded-3 ps-2 pe-2 border-0"
          aria-labelledby="dropdownMenuLink"
        >
          <li>
            <a
              class="dropdown-item rounded-2 cursor"
              (click)="setSearchKey('illus')"
              >Illustration</a
            >
          </li>
          <li>
            <a
              class="dropdown-item rounded-2 cursor"
              (click)="setSearchKey('collect')"
              >Collections</a
            >
          </li>
          <li>
            <a
              class="dropdown-item rounded-2 cursor"
              (click)="setSearchKey('aiImage')"
              >AI Images</a
            >
          </li>
        </ul>

        <input
          type="search"
          class="search-box boxz form-control"
          [placeholder]="
            searchKey == 'Illustration'
              ? 'Search for illustrations'
              : searchKey == 'Collections'
              ? 'Search for Collections'
              : searchKey == 'AI Images'
              ? 'Search for AI Images'
              : ''
          "
          [formControl]="typeahead"
          (input)="suggest()"
          (keyup.enter)="navigateTo()"
        />
        <a
          [routerLink]="['/search/']"
          [queryParams]="{ value: typeahead.value, searchKey: searchKey }"
          [class]="
            typeahead.value ? 'btn btn-ib-light' : 'btn btn-ib-light disable'
          "
          id="button-addon2"
        >
          <i class="fas fa-search"></i>
        </a>
      </div>

      <!-- <div class="dp hide-dropdown hide-sm dropdown ms-3">
        <button
          style="padding: 13px"
          class="ft-size boxz border-0 btn btn-lg btn-ib-light dropdown-toggle"
          id="bd-versions"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span class="hide-sm">{{ searchKey }}</span>
        </button>

        <ul
          class="shadow mb-5 bg-body rounded border-0 dropdown-menu dropdown-menu-end"
        >
          <div class="">
            <li>
              <a class="dropdown-item" (click)="setSearchKey('illus')"
                >Illustration</a
              >
            </li>
            <li>
              <a class="dropdown-item" (click)="setSearchKey('collect')"
                >Collections</a
              >
            </li>
          </div>
        </ul>
      </div> -->

      <div
        #autoSuggestion
        class="suggestions"
        [hidden]="!(suggestions?.length > 0 || typeahead?.value?.length > 0)"
      >
        <span *ngIf="searchKey == 'Illustration'">
          <a
            (click)="onSuggestionClick()"
            class="overflow-text"
            *ngFor="let s of suggestions"
            routerLink="/illustration/{{ s.slug }}"
          >
            <img
              [src]="getSEOImage(s.previewUrl || s.jpeg || s.png)"
              alt="{{ s.title }}"
              class="skeleton--thumbnial"
            />
            {{ s.title }}
          </a></span
        >
        <span *ngIf="searchKey == 'Collections'">
          <a class="overflow-text"
            (click)="onSuggestionClick()"
            *ngFor="let s of suggestions"
            routerLink="/illustration-collection/{{ s.slug }}"
          >
            <img
              [src]="getSEOImage(s.thumbUrl)"
              alt="{{ s.collectionName }}"
              class="skeleton--thumbnial"
            />
            {{ s.collectionName }}
          </a></span
        >
        <span *ngIf="searchKey == 'AI Images'">
          <a class="overflow-text"
            (click)="onSuggestionClick()"
            *ngFor="let s of suggestions"
            routerLink="/ai-image/{{ s.slug }}"
          >
            <img
              [src]="getSEOImage(s.previewUrl || s.jpeg || s.png)"
              alt="{{ s.title }}"
              class="skeleton--thumbnial responsive-thumbnail"
            />
            {{ s.title }}
          </a></span
        >

        <span *ngIf="suggestions?.length === 0 && typeahead?.value?.length > 0">
          No data found
        </span>
      </div>
    </form>
  </div>
</nav>
